import { CheckCircle, Activity, Server, Shield, Search, Globe, LayoutDashboard } from 'lucide-react';
import PageLayout from '../components/PageLayout';

const SERVICES = [
  { icon: Globe,           name: 'Website',          desc: 'zenithcipher.com marketing site & app shell' },
  { icon: Server,          name: 'API',              desc: 'Core REST API (scanning, auth, accounts)' },
  { icon: Search,          name: 'Wallet Scanner',   desc: 'On-chain risk analysis engine' },
  { icon: Shield,          name: 'Authentication',   desc: 'Login, registration & Google Sign-In' },
  { icon: LayoutDashboard, name: 'Dashboard',        desc: 'User dashboard, history & API keys' },
];

const StatusPill = () => (
  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold bg-green-500/10 text-green-400 border border-green-500/20">
    <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" />
    Operational
  </span>
);

export default function Status() {
  return (
    <PageLayout
      badge="System Status"
      badgeColor="green"
      title="Service Status"
      subtitle="Live operational status of all ZenithCipher services."
    >
      <div className="max-w-4xl mx-auto px-5 sm:px-8 pb-24">

        {/* Overall banner */}
        <div className="glass-card border border-green-500/20 bg-green-500/[0.04] p-6 rounded-2xl flex items-center gap-4 mb-10">
          <div className="w-11 h-11 rounded-xl bg-green-500/10 border border-green-500/20 flex items-center justify-center flex-shrink-0">
            <CheckCircle size={20} className="text-green-400" />
          </div>
          <div>
            <h2 className="text-white font-bold text-lg">All Systems Operational</h2>
            <p className="text-slate-500 text-xs mt-0.5 flex items-center gap-1.5">
              <Activity size={11} /> Last checked {new Date().toLocaleString()}
            </p>
          </div>
        </div>

        {/* Per-service list */}
        <div className="space-y-3">
          {SERVICES.map(({ icon: Icon, name, desc }) => (
            <div
              key={name}
              className="glass-card border border-white/[0.06] p-5 rounded-xl flex items-center gap-4"
            >
              <div className="w-10 h-10 rounded-lg bg-white/[0.04] border border-white/[0.07] flex items-center justify-center flex-shrink-0">
                <Icon size={16} className="text-[#00E5FF]" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-white">{name}</h3>
                <p className="text-xs text-slate-500 truncate">{desc}</p>
              </div>
              <StatusPill />
            </div>
          ))}
        </div>

        <p className="text-center text-xs text-slate-600 mt-10">
          For incident reports or to report an outage, contact{' '}
          <a href="mailto:support@zenithcipher.com" className="text-[#00E5FF] hover:underline">
            support@zenithcipher.com
          </a>.
        </p>
      </div>
    </PageLayout>
  );
}
